import { useSelector } from 'react-redux';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { Tariff } from 'reactApp/types/Billing';

export const useTariffs = ({ isPro, isDiscount }: { isPro: boolean; isDiscount: boolean }): Tariff[] => {
    const proTariff = useSelector(ProductsSelectors.getProTariffForUser);
    const discountTariff = useSelector(ProductsSelectors.getQuotaDiscountTariffForUser);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const defaultTariffs = useSelector(ProductsSelectors.getNonSpecialTariffs);

    if (isPro && proTariff) {
        return [proTariff];
    } else if (isDiscount && discountTariff) {
        return [discountTariff];
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const tariffs = defaultTariffs.filter((t) => t.products.some((p) => p.period === '1y'));

    return tariffs.slice(0, 3);
};
